import img from './premium_icon.png';
export default ({ size }) => <img src={img} height={size} width={size}></img>;
